import { render, staticRenderFns } from "./CallFeeCommission.vue?vue&type=template&id=abc12828&scoped=true"
import script from "./CallFeeCommission.vue?vue&type=script&lang=js"
export * from "./CallFeeCommission.vue?vue&type=script&lang=js"
import style0 from "./CallFeeCommission.vue?vue&type=style&index=0&id=abc12828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc12828",
  null
  
)

export default component.exports